import { useEffect } from 'react'

import { SubmitHandler, UseFormProps, UseFormReturn } from 'react-hook-form'
import { z } from 'zod'

import { useFormWithSchema } from '@fortem-monorepo/react-spa'
import { Form } from '@fortem-monorepo/react-ui'

import { v2 as v2Mutations } from '@/react-query/mutations/client-pricing'

const schema = z.object({
  org_ids: z.array(z.coerce.number()).min(1),
  value_date: z.string(),
})

export type SchemaType = z.infer<typeof schema>

export interface SendEmailsToClientsFormProps extends Omit<UseFormProps<SchemaType>, 'resolver'> {
  children?: ((form: UseFormReturn<SchemaType>) => React.ReactNode) | React.ReactNode
  onSubmit?: SubmitHandler<SchemaType>
}

export const SendEmailsToClientsForm: React.FC<SendEmailsToClientsFormProps> = ({
  children,
  onSubmit,
  ...props
}) => {
  const form = useFormWithSchema({ mode: 'all', defaultValues: { org_ids: [] }, ...props }, schema)

  const sendEmailsToClientsMutation = v2Mutations.sendEmailToClients()

  const submit = form.handleSubmit(
    onSubmit ??
      (async (data, _e) => {
        await sendEmailsToClientsMutation.mutateAsync(data)
        form.reset()
      }),
  )

  useEffect(() => {
    form.trigger()
  }, [])

  return (
    <Form {...form}>
      <form onSubmit={submit}>{typeof children === 'function' ? children(form) : children}</form>
    </Form>
  )
}
